import React, { useEffect, useState } from "react"
import { Box, Typography, Button, IconButton } from "@mui/material"
import { Cached as ReloadIcon, Close as CloseIcon } from "@mui/icons-material"
import PropTypes from "prop-types"
import { useEveListen } from "react-eve-hook"
import { USER_UPDATE_FAILURE, USER_UPDATE_SUCCESS } from "../../../../Constraints"

const styles = {
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: '0 8px',
    },
    title: {
        color: "white",
    },
    message: {
        text: {

        },
    },
    reload: {
        button: {

        },
        icon: {
            color: "white",
        },
    },
    close: {
        button: {

        },
        icon: {
            color: "white",
        },
    }
}

const UserListHeaderView = ({onAddUser, onImport, onDownload, onReload, onClose}) => {
    
    const [successText, setSuccessText] = useState()
    const [failureText, setFailureText] = useState()

    useEffect(() => {
        setSuccessText(null)
        setFailureText(null)
    }, [])

    useEffect(() => {
        const tm = setTimeout(() => setSuccessText(null), 3000)
        return () => {
            clearTimeout(tm)
        }
    }, [successText])

    useEffect(() => {
        const tm = setTimeout(() => setFailureText(null), 3000)
        return () => {
            clearTimeout(tm)
        }
    })

    useEveListen(USER_UPDATE_SUCCESS, () => {
        setSuccessText("更新に成功しました")
    })

    useEveListen(USER_UPDATE_FAILURE, () => {
        setFailureText("更新に失敗しました")
    })

    return (
        <Box style={styles.root}>
            <Typography style={styles.title}>ユーザ管理</Typography>
            <Box style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                {successText && <Typography style={{ ...styles.message.text, color: '#03af03', }}>{successText}</Typography>}
                {failureText && <Typography style={{ ...styles.message.text, color: "#dd3e3e" }}>{failureText}</Typography>}
                <Button onClick={onAddUser} style={{ color: "white", fontSize: "12px" }}>新規ユーザ</Button>
                <Button onClick={onImport} style={{ color: "white", fontSize: "12px" }}>インポート</Button>
                <Button onClick={onDownload} style={{ color: "white", fontSize: "12px" }}>ダウンロード</Button>
                <IconButton style={styles.reload.button} onClick={onReload}>
                    <ReloadIcon style={styles.reload.icon} />
                </IconButton>
                <IconButton style={styles.close.button} onClick={onClose}>
                    <CloseIcon style={styles.close.icon} />
                </IconButton>
            </Box>
        </Box>
    )
}

UserListHeaderView.propTypes = {
    onAddUser: PropTypes.func,
    onImport: PropTypes.func,
    onDownload: PropTypes.func,
    onReload: PropTypes.func,
    onClose: PropTypes.func,
}

export default UserListHeaderView